import React from 'react'
import './Header.css'
import logo from '../../Assets/logo.png';
import { Link } from 'react-router-dom';

const Header = () => {
    return (
        <>
            <header>
                <Link to={`/`} className="logo">
                    <img src={logo} alt="PARTSKLIK LOGO" />
                </Link>
            </header>
        </>
    )
}

export default Header
